/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
// import ToggleOffIcon from "@mui/icons-material/ToggleOff";
// import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { TableCell, TableRow } from "@mui/material";
import React from "react";
import Table from "../../../../components/common/new/Table/Table";
import { EXAM_MEMBER_SEAECH_TABLE_COL } from "../../../../contants/table/memberSearch";
import tableStyle from "../../../../theme/styles/table";
// import DeleteIcon from "../../../../assets/svg/Delete";
import styles from "./styles";
import Typography from "../../../../components/common/new/Typography/Typography";
// import EyeIcon from "../../../../assets/svg/Eye";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const getRows = ({ searchData }) =>
  searchData?.map((memberInfo) => {
    return (
      <TableRow>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {memberInfo.memberId}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {memberInfo.fullName}
          </Typography>{" "}
          <br />
          <div style={styles.tableBox}>
            <LocationOnIcon style={tableStyle.locationIcon} />{" "}
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {memberInfo.addressLine1}
              </Typography>
            </div>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <PhoneIcon style={tableStyle.icon} />
          <Typography style={styles.typoghrphyStyle}>
            {" "}
            {memberInfo.mobileNumber}
          </Typography>{" "}
          <br />
          <div style={styles.tableBox}>
            {" "}
            <EmailIcon style={tableStyle.icon} />
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.emailId || "-"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.divisionName || "-"}{" "}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.areaName || "-"}{" "}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.clusterName || "-"}{" "}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.zoneName || "-"}{" "}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.regionName || "-"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.chapterName || "-"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.districtName || "-"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.blockName || "-"}{" "}
            </Typography>
          </div>
        </TableCell>
        {/* {showStatusColumn && (
          <TableCell style={tabelCellWidth.medium}>
            <div style={styles.tableBox}>
              <StatusIcon label={memberInfo.status} />
            </div>
          </TableCell>
        )} */}
        {/* <TableCell style={tabelCellWidth.medium}>
          <div style={styles.tableBox}>
            <EyeIcon />
          </div>
        </TableCell> */}
      </TableRow>
    );
  });

function MemberTable({
  searchData,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onMemberStatusToggleForHelpDesk,
  onSelectMember,
  hasPermission,
  showStatusColumn,
  onEdit,
  onToggleHDC,
  isChapterSi,
  isHelpDesk,
  isAreaSi,
  isClusterSi,
  isZoneSi,
  isHelpDeskAdmin,
  onMemberReactivateToggle,
}) {
  const columns = EXAM_MEMBER_SEAECH_TABLE_COL;

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          onSelectMemberForTransfer,
          onSelectMember,
          hasPermission,
          onMemberStatusToggle,
          onMemberStatusToggleForHelpDesk,
          showStatusColumn,
          isChapterSi,
          isHelpDesk,
          isAreaSi,
          isClusterSi,
          isZoneSi,
          onEdit,
          onToggleHDC,
          isHelpDeskAdmin,
          onMemberReactivateToggle,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          // textAlign: "left",
        }}
      />
    </div>
  );
}

export default MemberTable;
